import React from 'react';
import { Lock, Pencil, MapPin } from 'lucide-react';
import { Regional, REGIAO_UL_DROPDOWN_OPTIONS } from './types';

type RegionaisTableProps = {
  data: Regional[];
  editedRegions: Map<string, string>;
  onRegionChange: (idDistribuidor: string, newRegion: string) => void;
};

export const RegionaisTable: React.FC<RegionaisTableProps> = ({
  data,
  editedRegions,
  onRegionChange,
}) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr className="bg-gray-50">
            <th
              scope="col"
              className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
            >
              <div className="flex items-center gap-1.5">
                <Lock className="w-3 h-3 text-gray-400" />
                ID Distribuidor
              </div>
            </th>
            <th
              scope="col"
              className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
            >
              <div className="flex items-center gap-1.5">
                <Lock className="w-3 h-3 text-gray-400" />
                Nome Completo Distribuidor
              </div>
            </th>
            <th
              scope="col"
              className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
            >
              <div className="flex items-center gap-1.5">
                <Lock className="w-3 h-3 text-gray-400" />
                Estado
              </div>
            </th>
            <th
              scope="col"
              className="px-6 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
            >
              <div className="flex items-center gap-1.5">
                <Pencil className="w-3 h-3 text-blue-500" />
                Regional UL
              </div>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {data.map((regional) => {
            const isEdited = editedRegions.has(regional.idDistribuidor);
            const currentRegion = isEdited
              ? editedRegions.get(regional.idDistribuidor)!
              : regional.regiaoUL;

            return (
              <tr
                key={regional.idDistribuidor}
                className={`transition-colors ${
                  isEdited
                    ? 'bg-blue-50/50 hover:bg-blue-50'
                    : 'bg-white hover:bg-gray-50'
                }`}
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-md bg-gray-100 text-xs font-mono font-medium text-gray-700">
                    {regional.idDistribuidor}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="text-sm font-medium text-gray-900">
                    {regional.nomeCompletoDistribuidor}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="text-sm text-gray-600">
                    {regional.estado || '-'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <select
                    value={currentRegion}
                    onChange={(e) => onRegionChange(regional.idDistribuidor, e.target.value)}
                    className={`w-full max-w-[220px] pl-3 pr-3 py-2 text-sm rounded-lg border transition-all cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500/30 ${
                      isEdited
                        ? 'bg-blue-50 border-blue-300 text-blue-800 font-medium'
                        : currentRegion === ''
                          ? 'bg-white border-gray-200 text-gray-400 hover:border-gray-300'
                          : 'bg-white border-gray-200 text-gray-700 hover:border-gray-300'
                    }`}
                    aria-label={`Regional UL do distribuidor ${regional.nomeCompletoDistribuidor}`}
                  >
                    <option value="">Selecione a regiao</option>
                    {REGIAO_UL_DROPDOWN_OPTIONS.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {data.length === 0 && (
        <div className="flex flex-col items-center justify-center py-16">
          <div className="bg-gray-100 rounded-full p-3 mb-3">
            <MapPin className="w-6 h-6 text-gray-400" />
          </div>
          <p className="text-sm text-gray-500">Nenhuma regional encontrada</p>
        </div>
      )}
    </div>
  );
};
